import { FormGroup } from '@angular/forms';
import { AppLookupResponse } from '../../shared/models/app-lookup-response';
import { JobSkill } from '../../shared//models/job-skill';

export class JobPost {
    public id: string;
    public title: string;
    public description: string;
    public expiryDate: Date;
    public educationLevel: string;
    public experience: number;
    public sector: string;
    public salaryType: string;
    public type: string;
    public minimumSalary: number;
    public maximumSalary: number;
    public skills: JobSkill[];
    public location: string;
    public city: string;
    public country: string;
    public workType: number;
    public employerAccountId: string;
    public languages: AppLookupResponse[];


    public static parseForm(form: FormGroup): JobPost {
        let jobPost = new JobPost();
        Object.assign(jobPost, form.value);
        jobPost.minimumSalary = Number.parseInt(jobPost.minimumSalary.toString());
        jobPost.maximumSalary = Number.parseInt(jobPost.maximumSalary.toString());
        jobPost.expiryDate = new Date(form.value.expiryDate["year"], form.value.expiryDate["month"], form.value.expiryDate["day"]);
        return jobPost;
    }

    public static parse(jsonData): JobPost {
        let jobPost = new JobPost();
        Object.assign(jobPost, jsonData);
        jobPost.expiryDate = new Date(jobPost.expiryDate);
        return jobPost;
    }
}
